// pages/portal/billing-topup.tsx
import PortalRedirect from '../../components/portal/layout/portal-redirect.component';

/**
 * Legacy route — redirects to /portal/credits per Phase 3 IA.
 * Kept for at least 30 days after Phase 6 flag flip; delete after.
 */
export default function BillingTopupRedirect() {
    return <PortalRedirect to="/portal/credits" />;
}
